module.exports = __webpack_public_path__ + "img/step_6.2e9bc5cb.webp";